import React,{useState} from "react";
import {
  Button,
  Icon,
  Card,
  Grid,
} from "semantic-ui-react";
import APIService from "../../Services/API/APIService";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import numeral from "numeral";


const DirectTransfer = (props) => {

  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const onDrop = React.useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length) {
      toast.error("Select a PDF/image receipt no larger than 10 MB.");
    }
    setFiles(acceptedFiles.slice(0, 1));
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    maxSize: 10 * 1024 * 1024,
    // accept: { "application/pdf": [".pdf"] },
  });

  const uploadReceipt = async () => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append(`file`, files[0]);

      formData.append(
        "values",
        JSON.stringify({
          reference: props.reference,
          guesthouse: true,
          reservationToken: props.reservationToken,
        })
      );

      let response = await APIService.postFormData(
        "/checkout/uploadPaymentReceipt",
        formData
      );

      setLoading(false);

      if (response.success) {
        const completed = await props.onSuccess(
          { reference: response.id },
          props.paymentMode,
          props.total
        );
        if (completed) {
          props.toggleModal(false);
        }
   
      } else {
        toast.warn("Upload failed");
      }
    } catch (error) {
      console.log("error", error);
      toast.error(typeof error === "string" ? error : error?.message || "Receipt submission failed. Please try again.");
      setLoading(false);
    }
  };

  return (
    <div>
      <Grid centered style={{ marginTop: 10, marginBottom: 10 }}>
        <Card centered>
          <Card.Content>
            <Card.Meta>Upload your payment receipt</Card.Meta>
          </Card.Content>
          <Card.Content>
            <Grid columns={2} textAlign="left">
              <Grid.Row>
                <Grid.Column>Amount</Grid.Column>
                <Grid.Column>
                  <b>₦{numeral(props?.total).format("0,0")}</b>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
          <Card.Content>
            <div
              {...getRootProps()}
              style={{
                border: "1px dashed black",
                marginBottom: "5px",
                padding: "10px",
              }}
            >
              <input {...getInputProps()} />
              {isDragActive ? (
                <p>Drop the file here ...</p>
              ) : (
                <p>
                  Drag and drop the payment receipt here, or click to select
                  file (10MB max)
                </p>
              )}
            </div>
            {files.length !== 0 && (
              <div>
                <Icon name="file pdf outline" />
                {files[0].name}
              </div>
            )}
          </Card.Content>
          <Card.Content>
            <Button
              loading={loading}
              onClick={uploadReceipt}
              positive
              style={{ width: "100%" }}
              disabled={files.length < 1}
            >
              Confirm Request
            </Button>
          </Card.Content>
        </Card>
      </Grid>
    </div>
  );
};

export default DirectTransfer;
